/*
 * @Author: caiqin.xie
 * @since: 2023-06-09 14:56:39
 * @lastTime: 2023-11-23 16:11:56
 * @LastEditors: caiqin.xie
 * @message: 博客列表右侧最新产品及订阅
 */
import React from "react";
import Subscribe from "../Subscribe";
import {BLOGTYPE, DOMAIN_API} from "@/common/const"
import styles from "../../index.module.scss";
import LazyMedia from "@/components/LazyMedia";

interface IProduct {
  id: string; // 产品id
  cover: string; // 产品封面
  coverAlt: string; // 产品封面alt
  briefIntroduction: string; // 产品简介
  name: string; // 产品名称
}

interface IProps {
  ctry: string;
  words: Record<string, string>;
  newestProduct: IProduct; // 最新产品
}


const NewestProduct = (props:IProps) => {
  const {ctry, words, newestProduct} = props
  return (
    <div className={styles['blog-right-top']}>
      <Subscribe
        ctry={ctry}
        words={words}
        contentTypeId={BLOGTYPE}
        sourcePage='1'
        sourceUrl={`${DOMAIN_API}/blog`} />
      {
        newestProduct &&
        <div className={styles['product-wrap']}>
          <LazyMedia type="image" className={styles['produce-img']} src={newestProduct?.cover} alt={newestProduct?.coverAlt} />
          <p className={styles['produce-name']}>{newestProduct?.name}</p>
          <p className={styles['produce-info']}>{newestProduct?.briefIntroduction}</p>
          {newestProduct && newestProduct.name && (
              <button className={styles["load-more-purple"]}>
                <a href={`/${ctry}/support/product-support/${newestProduct.name}`}>{words?.common_learn_more}</a>
              </button>
          )}
          {/* Learn More */}
        </div>
      }
    </div>
  )
}
export default NewestProduct
